package ai.jessie.web.pages.organisations

import ai.jessie.web.onboarding.onboardingProblem
import ai.jessie.web.onboarding.organisationRequiredProblem
import ai.jessie.web.onboarding.validOrganisationId
import ai.jessie.web.theme.AlertStyle
import ai.jessie.web.theme.appFrame
import ai.jessie.web.theme.homeSideItems
import ai.jessie.web.work.unavailableWorkProblem
import ai.jessie.web.work.validWorkId
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.dom.Div

// UC-008 steps 8–12. An invalid work ID sends no request and shows the same neutral absence as
// an entry outside the member's permitted work (A5).
@Page("{organisationId}/work/{workId}")
@Composable
fun organisationWorkEntryPage(ctx: PageContext) {
    val organisationId = ctx.route.dynamicParams["organisationId"].orEmpty()
    val workId = ctx.route.dynamicParams["workId"].orEmpty()
    when {
        !validOrganisationId(organisationId) ->
            appFrame(
                organisationId,
                "/organisations/$organisationId/work",
                "Arbeit",
                side = homeSideItems(organisationId),
            ) {
                Div(attrs = AlertStyle.toAttrs()) {
                    onboardingProblem(organisationRequiredProblem(), busy = false)
                }
            }
        !validWorkId(workId) ->
            appFrame(
                organisationId,
                "/organisations/$organisationId/work",
                "Arbeit",
                side = homeSideItems(organisationId),
            ) {
                Div(attrs = AlertStyle.toAttrs()) {
                    onboardingProblem(unavailableWorkProblem(), busy = false)
                }
            }
        else -> key(organisationId, workId) { workContent(organisationId, workId) }
    }
}
